export enum HiddenUIElement {
    Trade, Dice, TileProbabilityViews, RoadActionButton, SettlementActionButton, CityActionButton, BuyDevCardActionButton, EndTurnActionButton,
    Bank,
    PlayerViewResourceCards,
    HowToWinFloatingVP,
    InformationButton,
}

export enum BeginnerModeLevel {
    Level1 = 0, Level2 = 1, End = 2,
}

export enum BeginnerModePlayer {
    HumanPlayer, BotPlayer,
}
